import { c as _c } from "react/compiler-runtime";
import { type Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { type AppType } from 'next/app';
import { Geist } from 'next/font/google';
import { api } from '@/utils/api';
import Head from 'next/head';
import '@/styles/globals.css';
const geist = Geist({
  subsets: ['latin']
});
type ComponentWithLayout = AppType<{
  session: Session | null;
}> & {
  getLayout?: (page: React.ReactNode) => React.ReactNode;
};
const MyApp: AppType<{
  session: Session | null;
}> = t0 => {
  const $ = _c(15);
  const {
    Component,
    pageProps: t1
  } = t0;
  let pageProps;
  let session;
  if ($[0] !== t1) {
    ({
      session,
      ...pageProps
    } = t1);
    $[0] = t1;
    $[1] = pageProps;
    $[2] = session;
  } else {
    pageProps = $[1];
    session = $[2];
  }
  const getLayout = (Component as ComponentWithLayout).getLayout ?? _temp;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Head><title>Redsofa управление производством</title><meta name="description" content={"\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E\u043C"} /><meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" /><link rel="icon" href="/favicon.ico" /></Head>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== Component || $[5] !== pageProps) {
    t3 = <Component {...pageProps} />;
    $[4] = Component;
    $[5] = pageProps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== getLayout || $[8] !== t3) {
    t4 = getLayout(t3);
    $[7] = getLayout;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <div className={`${geist.className} flex h-dvh min-h-0 flex-col overflow-hidden`}>{t4}</div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== session || $[13] !== t5) {
    t6 = <>{t2}<SessionProvider session={session}>{t5}</SessionProvider></>;
    $[12] = session;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default api.withTRPC(MyApp);
function _temp(page) {
  return page;
}